/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "parog-web/components/abstract/scale-survey-edition-form";
import YmrsDeclaredJournalEvent from "parog-web/models/ymrs-declared-journal-event";
import ymrsScoreDescription from "parog-web/utils/ymrs-score-description";

export default class YMRSEditionComponent extends ScaleSurveyEditionFormComponent {
  static forcDisplayName = "Young Mania Rating Scale";

  static fullComponentId = "scale-surveys/ymrs-edition-form";

  static journalEventClass = YmrsDeclaredJournalEvent;

  get numberOfItems() {
    return 11;
  }

  get maximalScore() {
    return 60;
  }

  get validationNames() {
    return [
      "L'élévation de l'humeur",
      "L'activité motrice et énergie augmentées",
      "L'intérêt sexuel",
      "Le sommeil",
      "L'irritabilité",
      "Le discours (débit et quantité)",
      "Le langage – troubles de la pensée",
      "Le contenu",
      "Le comportement agressif et perturbateur",
      "L'apparence",
      "L'introspection"
    ];
  }

  // payload will either be a changeset (when template refreshes),
  // or a POJO (when the form is saved).
  _computeScore(payload) {
    const number = this.questionIds.reduce(
      (total, index) => total + parseInt(get(payload, index)),
      0
    );

    return {
      number,
      description: ymrsScoreDescription(number)
    };
  }
}
